<template>
  <el-main class="login-container">
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="10">
        <p class="login-label">Iniciar sesión</p>
        <el-form>
          <el-input placeholder="Email" v-model="userEmail" tabindex="1"></el-input>
          <el-input type="password" placeholder="Contraseña" v-model="password" tabindex="2" @keyup.enter.native="sendLoginRequest"></el-input>
        </el-form>
        <span class="forgot-password" tabindex="3" v-on:click="dialogVisible = true">¿Olvidaste tu contraseña?</span>
        <el-button type="primary" v-on:click="sendLoginRequest">Iniciar sesión</el-button>
      </el-col>
    </el-row>
    <el-dialog title="Recuperar Contraseña" :visible.sync="dialogVisible">
      <div class="recover-password-container">
        <el-form :model="recoverPassword" status-icon :rules="rules" ref="recoverPassword">
          <el-form-item label="Email" prop="email">
            <el-input class="card-input" placeholder="" prefix-icon="el-icon-edit" v-model="recoverPassword.email" auto-complete="off"></el-input>
          </el-form-item>
          <el-button type="primary" v-on:click="validateAndSumbit('recoverPassword')" style="width:100%; background-color:#2873DE; border:none">Enviar</el-button>
        </el-form>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { loginUser, getAdvisorsByQuery, recoverPassword } from '@/graphql'

export default {
  name: 'login',
  data() {
    return {
      userEmail: '',
      password: '',
      userExists: 1,
      userData: {},
      dialogVisible: false,
      recoverPassword: {
        email: ''
      },
      rules: {
        email: [
          {
            required: true,
            message: "Debes proporcionar un email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Es necesario un email válido, ejemplo@email.com",
            trigger: "blur"
          }
        ]
      }
    }
  },
  methods: {
    sendLoginRequest() {
      this.$apollo.mutate({
        mutation: loginUser,
        variables: {
          username: this.userEmail,
          password: this.password
        },
      }).then((data) => this.successHandler(data.data)
      ).catch((error) => {
        this.$message({
          type: 'error',
          message: 'Ocurrió un error, intenta más tarde'
        })
      })
    },
    successHandler (data) {
      // User login was succesful
      if (data.advisorLogin) {
        const redirectUrl = data.advisorLogin.advisor.isAdmin ? '/lista-de-asesores' : '/lista-de-analisis'
        this.saveSession(data.advisorLogin.advisor.id, data.advisorLogin.token)
        this.$store.dispatch( 'toggleMenu' , true )
        this.$store.dispatch( 'saveUserData', data.advisorLogin).then(this.$router.push(redirectUrl))
      } else if (data.errors){
        this.$message({
          type: 'error',
          message: 'El usuario o contraseña incorrecta'
        })
      }
    },
    saveSession (id, token) {
      localStorage.setItem('user_id', id)
      localStorage.setItem('token', token)
    },
    validateAndSumbit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sendRecoverPassworRequest(this.recoverPassword.email)
        } else {
          return false;
        }
      })
    },
    sendRecoverPassworRequest(email) {
      this.$apollo.query({
        query: recoverPassword,
        variables: {
          email,
        }, fetchPolicy: 'network-only'
      }).then((data) => {
        this.dialogVisible = false
        this.$message({
          type: "success",
          message: data.data.recoverPassword.msg
        })}
      )
    }
  },
};
</script>

<!-- Component styles if required -->
<style scoped>

  .el-main {
  line-height: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  }

  .el-input {
    margin-bottom: 15px;
  }

  .el-button--primary {
    width: 100%;
    float: left;
  }

  .login-label {
    color: white;
    font-size: 18px;
    font-weight: 500;
    margin: 19px 0;
  }

  .login-container {
    background-image: url('/static/login-background.png');
    background-size: cover;
    height: calc(100% - 60px);
  }

  .forgot-password {
    font-size: 12px;
    color: white;
    text-decoration: none;
    float: right;
    cursor: pointer;
    margin-bottom: 25px;
  }

  .recover-password-container {
    height: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue